import { render } from "./MoveDeviceModal.vue?vue&type=template&id=36e321ec&ts=true"
import script from "./MoveDeviceModal.vue?vue&type=script&lang=ts"
export * from "./MoveDeviceModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__